import PlaceSearch from './PlaceSearch';
import PlaceList from './PlaceList';
import Button from '../shared/Button';
import LocationInput from '../TripSetup/LocationInput';
import useTripStore from '../../context/TripStore';
import { useItineraryGenerator } from '../../hooks/useItineraryGenerator';
import { useState } from 'react';

const ListBuilder = () => {
  const places = useTripStore((state) => state.places);
  const startLocation = useTripStore((state) => state.trip?.startLocation);
  const setCurrentStep = useTripStore((state) => state.setCurrentStep);
  const { generate, error: generateError } = useItineraryGenerator();
  const [error, setError] = useState(null);

  const canGenerate = startLocation && places.length > 0;

  const handleGenerate = async () => {
    setError(null);
    try {
      await generate();
      setCurrentStep('itinerary');
    } catch (err) {
      setError(err.message);
      console.error('Failed to generate itinerary:', err);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-light mb-6 tracking-tight">Plan Your Trip</h1>

      <div className="space-y-4">
        <LocationInput type="start" label="Starting Point" />

        <div className="border-t border-gray-200 pt-4">
          <PlaceSearch />
        </div>

        <PlaceList />
      </div>

      {/* Error message */}
      {(error || generateError) && (
        <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-700">{error || generateError}</p>
        </div>
      )}

      <div className="mt-6">
        <Button
          onClick={handleGenerate}
          disabled={!canGenerate}
          className="w-full"
        >
          Generate Itinerary
        </Button>
        {!canGenerate && (
          <p className="mt-2 text-xs text-gray-500 text-center">
            {!startLocation && 'Set a starting location'}
            {startLocation && places.length === 0 && 'Add at least one place to visit'}
          </p>
        )}
      </div>
    </div>
  );
};

export default ListBuilder;
